/**
 * VendorPath — the inline click-path for class-X actions (DC-13, AC-015):
 * "where in the vendor console the value lives → which Segmently field receives it".
 * Content is data (`ActivationAction.vendorPath`); this component only renders it.
 */
import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

export interface VendorPathProps {
  steps: string[];
  title?: string;
  'data-testid'?: string;
}

export const VendorPath: React.FC<VendorPathProps> = ({ steps, title = 'Where to get it', 'data-testid': testId }) => {
  const theme = useTheme();
  if (steps.length === 0) return null;
  return (
    <Box
      data-testid={testId}
      sx={{
        mt: 1.25,
        p: theme.spacing(1.25, 1.5),
        borderRadius: 1.5,
        bgcolor: theme.palette.action.hover,
      }}
    >
      <Typography variant="caption" fontWeight={500} component="div">
        {title}
      </Typography>
      <Box component="ol" sx={{ m: theme.spacing(0.5, 0, 0), pl: 2.25, color: theme.palette.text.secondary }}>
        {steps.map((step, index) => (
          <Typography component="li" variant="caption" key={`${index}-${step}`} sx={{ display: 'list-item', my: 0.25 }}>
            {step}
          </Typography>
        ))}
      </Box>
    </Box>
  );
};

export default VendorPath;
